import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function RegisterExit (){
  const {user} = useUser()
  let view = contentLayout[modules.RegisterExit]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.RegisterExit.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.RegisterExit}></Index>
 )
}

export default RegisterExit